import React, { useState } from 'react'
import { Accordion, Form, Icon, Segment } from 'semantic-ui-react'

export const PrinciapalDesktopConfig = () => {
    const [internalState, setInternalState] = useState({
        CongifIndex: 0,
    })
    const ClickAccordionConfig = async () => {

    }
    return (
        <div className="ui segments">
            <Segment>
                <Accordion>
                    <Accordion.Title active={internalState.CongifIndex === 0} index={0} onClick={ClickAccordionConfig} >
                        <Icon name='dropdown' /> Configuración Bitso
                    </Accordion.Title>
                    <Accordion.Content active={internalState.CongifIndex === 0}>
                        <Form>
                            <Form.Field width={4}>
                                <label>Comisión</label>
                                <input placeholder='Comisión' />
                            </Form.Field>
                        </Form>
                    </Accordion.Content>

                </Accordion>
            </Segment>
        </div>
    )
}
